<template>
  <sn-expansion-panels
    v-model="panel"
    expandable
    hide-shadow
    multiple
    style="width: 100%; height: auto"
  >
    <sn-expansion-panel
      v-for="(permissionGroup, groupIndex) in permissionGroups"
      :key="groupIndex + '-group'"
      width="100%"
    >
      <template v-slot:header>
        <div class="toggle-header">
          <h4 class="toggle-title">
            {{ permissionGroup.name }}
          </h4>
          <sn-tooltip
            v-if="permissionGroup.showLabelTooltip"
            direction="right"
            max-width="400px"
          >
            <template v-slot:activator>
              <v-icon
                :data-cy="'transaction-permission-info'"
                class="ml-1 info-icon"
                color="#1F1F1F"
              >
                $snInfo
              </v-icon>
            </template>
            <span
              class="sn-font-primary sn-font-weight-regular sn-text-white"
            >
              {{ permissionGroup.labelTooltipText }}
            </span>
          </sn-tooltip>
        </div>
      </template>
      <template v-slot:expansion>
        <div>
          <permission-row
            v-for="(setting, rowIndex) in permissionGroup.settings"
            :key="groupIndex + '-' + rowIndex + '-row'"
            :permission="setting"
            :non-default-permissions="nonDefaultPermissions"
            :view-only="viewOnly"
            class="permission-row item-border-bottom"
            @permissionChange="handleChange($event)"
          />
        </div>
      </template>
    </sn-expansion-panel>
  </sn-expansion-panels>
</template>

<script>
import PermissionRow from './permissionRow'

export default {
  name: 'PermissionGroups',
  components: {
    PermissionRow
  },
  props: {
    permissionGroups: {
      type: Array,
      required: true
    },
    nonDefaultPermissions: {
      type: Array,
      required: false,
      default: () => []
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      panel: undefined
    }
  },
  watch: {
    expanded (val) {
      this.expandAll(val)
    }
  },
  created () {
    this.expandAll(this.expanded)
  },
  methods: {
    expandAll (expanded) {
      const panel = []
      if (expanded) {
        this.permissionGroups.forEach((_group, index) => {
          panel.push(index)
        })
      }
      this.panel = panel
    },
    handleChange (changedPermissions) {
      this.$emit('permissionChange', changedPermissions)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.toggle-header {
  display: flex;
  align-items: center;
  gap: 4px;
}

.toggle-title {
  font-size: 22px !important;
  line-height: 32px !important;
  margin: 0;
  flex-shrink: 1;
}

.info-icon {
  flex-shrink: 0; // Ensure the icon stays the same size
}


.permission-row {
  margin: 0;
}
::v-deep .v-expansion-panel-header {
  min-height: 56px !important;
}

</style>
